module.exports = __webpack_public_path__ + "img/dashboard_white.dfe065ad.svg";